import React, { useState, useEffect } from "react";
import { Link } from "gatsby"
import Select from 'react-select';
import { Container, Row, Col } from 'react-bootstrap'
import "./LocationBlock.scss";
import BoxBlock from "../BoxBlock/Box"
import ContentModule from "../../modules/content_module";

import {OfficeList, AreaList} from "../../common/queries/common_use_query"

const Location = ({Module}) => {
    const[office_list, setOfficeList] = useState([]);
    const[filter_area, setFiltArea] = useState('');

    const{loading, error, data} = OfficeList();
    const{data:area_data} = AreaList();

    useEffect(() => {
        data?.offices?.length > 0 && setOfficeList(data?.offices);
    }, [data])

    useEffect(() =>{
        //console.log("filter_area", filter_area);
        if(filter_area){
            if(data?.offices && data?.offices?.length > 0){
                var all_office = data?.offices;
                var office_list =  [];
    
                all_office?.map((item, index) => {
                    if(filter_area?.value){
                        if(item?.areas.length > 0 && item?.areas?.some(item2 =>  item2.id === filter_area?.value)){
                            office_list.push(item);
                        }
                    } else{
                        office_list.push(item);
                    }
                    
                })
                setOfficeList(office_list)
            }
        }
    },[filter_area, data])

    const options =  [{ value: '', label: 'All Locations' }]

    area_data?.areas?.length > 0 && area_data?.areas?.map((item, index) => {
        options.push({value: item.id, label: item.area_name})
    })

    var branche_text = office_list?.length > 1 ? "branches" : "branch"

    return (
        <React.Fragment>
            <section className="location-block">
                <Container>
                    <Row>
                        <Col>
                            {Module.description && <ContentModule Content={Module.description} />}

                            <div className="filter-wrapper">
                                {filter_area ?
                                    <span className="sm-text">Showing {office_list?.length} {branche_text} across the {filter_area?.label}</span>
                                :
                                    <span className="sm-text">Showing all {office_list?.length} {branche_text}</span>
                                }

                                <div className="filter-boxes">
                                    <strong className="filter-box">Filter by:</strong>
                                    <Select 
                                        options={options}
                                        placeholder="All Locations" 
                                        className="react-select"
                                        classNamePrefix="react-select" 
                                        onChange={setFiltArea}                                        
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {office_list?.length > 0 && 
                            <div className="box-wrap">
                                {office_list.map((item, index) => (
                                    <BoxBlock key={index} BoxList={item} />
                                ))}
                            </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Location;
